import { normalizaTelefoneBR } from './financeiro'

function primeiroNome(nome) {
  return (nome || '').trim().split(/\s+/)[0] || ''
}

// Mensagem promocional da conferência TRIBUS (pos-acamp 2k26)
export function buildMensagemTribus(acampante) {
  const nome = primeiroNome(acampante?.name)
  return (
    `Graça e paz, ${nome}! 🙌\n\n` +
    `Tenho um presente pra você que participou do nosso *Acamp 2k26* ❤️‍🔥\n\n` +
    `Promoção na inscrição da nossa conferência *TRIBUS* ❤️‍🔥\n` +
    `Válida somente até *10/06* — aproveita essa oportunidade!\n\n` +
    `🎟️ Cupom: *ACAMP26*\n\n` +
    `🔗 https://middle.tec.br/event?s=conferencia-tribus---revival`
  )
}

export function buildTribusWaLink(acampante) {
  const phone = normalizaTelefoneBR(acampante?.contato)
  if (!phone) return null
  const msg = encodeURIComponent(buildMensagemTribus(acampante))
  return `https://wa.me/${phone}?text=${msg}`
}
